// import React from 'react';
// import AllInboxIcon from '@mui/icons-material/AllInbox';
import { resolveIcon } from './resolveIcon';

function prettyTitle(str = '') {
  return String(str)
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, (ch) => ch.toUpperCase());
}

export function transformModulesToMenu(dataModules = [], options = {}) {
  // const { iconMap = {} } = options;

  // const getIcon = (node) => {
  //   const keyIcon = node.module_icon;
  //   const keyName = node.module_name;
  //   if (keyIcon && iconMap[keyIcon]) return iconMap[keyIcon];
  //   if (keyName && iconMap[keyName]) return iconMap[keyName];
  //   if (keyIcon) return (props) => React.createElement('i', { className: keyIcon, ...props });
  //   return AllInboxIcon;
  // };

  const getIcon = (node) => {
    const keyIcon = resolveIcon(node.modules_icon);
    return keyIcon;
  };

  const buildUrl = (root, ancestors = [], node) => {
    const moduleId = node.modules_path ?? node.modules_name ?? node.name ?? String(node.id);
    const moduleNameForQuery = node.modules_name ?? node.name ?? String(node.id);
    return `/${encodeURIComponent(moduleId)}?name=${encodeURIComponent(moduleNameForQuery)}`;
  };

  const makeId = (node, suffix = '') => {
    const base = node.modules_name ?? node.name ?? String(node.id ?? '').replace(/\s+/g, '-');
    return suffix ? `${base}-${suffix}` : base;
  };

  const nodeToMenu = (node, root, ancestors = [], level = 1) => {
    const icon = getIcon(node);
    const title = node.alias ?? prettyTitle(node.modules_name ?? node.name ?? String(node.id));
    const disabled = node.is_active === false;
    const id = makeId(node);
    const common = {
      id,
      title,
      alias: node.alias,
      module_name: node.modules_name ?? node.name,
      module_path: node.modules_path,
      type: Array.isArray(node.children) && node.children.length > 0 ? 'collapse' : 'item',
      icon,
      level,
      disabled
    };

    if (Array.isArray(node.children) && node.children.length > 0) {
      return {
        ...common,
        children: node.children.map((child) => nodeToMenu(child, root, [...ancestors, node], level + 1)).filter(Boolean)
      };
    }
    return {
      ...common,
      url: buildUrl(root, ancestors, node)
    };
  };

  const groups = (dataModules || []).map((root) => {
    const rootId = root.modules_name ?? `group-${String(root.id ?? '')}`;
    const rootIcon = getIcon(root);
    const rootTitle = root.alias ?? prettyTitle(root.modules_name ?? String(root.id));
    const disabled = root.is_active === false;
    const hasChildren = Array.isArray(root.children) && root.children.length > 0;

    const rootMenu = hasChildren
      ? {
          id: rootId,
          title: rootTitle,
          alias: root.alias,
          type: 'collapse',
          icon: rootIcon,
          level: 0,
          disabled,
          children: root.children.map((child) => nodeToMenu(child, root, [], 1)).filter(Boolean)
        }
      : {
          id: `${root.modules_name || rootId}-self`,
          title: rootTitle,
          alias: root.alias,
          type: 'item',
          icon: rootIcon,
          url: buildUrl(root, [], root),
          module_name: root.modules_name,
          module_path: root.modules_path,
          level: 0,
          disabled
        };

    return {
      id: `group-${rootId}`,
      type: 'group',
      title: '',
      children: [rootMenu]
    };
  });

  return groups.filter((g) => Array.isArray(g.children) && g.children.length > 0);
}
